<template>
  <div class="big-con">
    <div class="b-header">
      <img class="bh-img" src="../assets/img/big-title.png" />
      <div class="bh-content flex-y-center">
        <div class="weather flex-y-center">
          <img class="w-icon" :src="weatherIcon[nowWeather.icon]" />
          <div class="w-txt">
            <span>{{ nowWeather.temp || '暂无' }}</span>
            <span v-if="nowWeather.temp" class="s">℃</span>
            <span v-if="nowWeather.text" class="info">{{ nowWeather.text }}/{{ nowWeather.dew }}℃~{{ nowWeather.temp }}℃/风力{{ nowWeather.windScale }}级/湿度{{ nowWeather.humidity }}%</span>
          </div>
        </div>
        <div class="time flex-x-center">
          <div class="date flex-x-center">
            <div class="t">星期{{ dayStr }}</div>
            <div class="d">{{ dateStr }}</div>
          </div>
          <div class="time-info flex-y-center">{{ timeStr }}</div>
          <div class="login-state flex-center" @click="closePage">
            <img class="l-img" src="../assets/img/login/normal.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="b-container">
      <div class="bc-main flex-x-between">
        <div class="bc-item-1">
          <land-planting class="mgn-top-50"></land-planting>
          <category-proportion class="mgn-top-70"></category-proportion>
        </div>
        <div class="bc-item-1">
          <agricultural-materials class="mgn-top-50"></agricultural-materials>
          <box-model title="气象站" class="mgn-top-70">
            <template v-slot:content>
              <div class="w-content">
                <div class="wc-info flex-x-between">
                  <img class="wc-img" :src="weatherIcon[nowWeather.icon]" />
                  <div class="wc-num">
                    <div class="num1">21°</div>
                    <div class="num2">多元</div>
                    <div class="num3">13/22℃</div>
                  </div>
                  <div class="wc-line"></div>
                  <div class="wc-detail">
                    <div class="wc-d-list flex-wrap">
                      <div class="wc-d-item flex-y-center">
                        <span>湿度</span>
                        <div class="num">{{ nowWeather.humidity }}%</div>
                      </div>
                      <div class="wc-d-item flex-y-center">
                        <span>雨水</span>
                        <div class="num">{{ nowWeather.precip }}mm</div>
                      </div>
                      <div class="wc-d-item flex-y-center">
                        <span>风力</span>
                        <div class="num">{{ nowWeather.windScale }}级</div>
                      </div>
                      <div class="wc-d-item flex-y-center">
                        <span>光照强度</span>
                        <div class="num">{{ nowWeather.cloud }}Lux</div>
                      </div>
                    </div>
                    <div class="wc-d-notice flex-y-center">
                      <img class="n-icon" src="../assets/img/notice.png" />
                      <span>{{ farmLandDetail.cityText }}气象预警</span>
                    </div>
                  </div>
                </div>
                <div class="wc-list-content">
                  <div class="wc-r-list">
                    <div class="num-part">
                      <canvas class="canvas" width="1420px" height="64px" id="ctxs"></canvas>
                    </div>
                    <div v-for="(item, index) in baseList" :key="index" class="r-item">
                      <div class="r-time">{{ item.hourStr }}时</div>
                      <div class="r-tag"></div>
                      <img class="r-img" :src="weatherIcon[item.icon]" />
                      <div class="r-num">{{ item.temp }}℃</div>
                      <div class="r-wind">{{ item.text }}</div>
                      <div class="r-wind">{{ item.windScale }}级</div>
                    </div>
                  </div>
                </div> 
              </div>
            </template>
          </box-model>
        </div>
        <div class="bc-item-2">
          <div class="title-part flex-y-center">
            <div class="t-select1">
              <select-box :sty="true" :list="farmLandList" :item="selItem" @sel="selEvent" keyword="type"></select-box>
            </div>
          </div>
          <div id="mapData" ref="mapData" :key="mapKey" class="map"></div>
        </div>
        <div class="bc-item-1">
          <processing-stage class="mgn-top-50"></processing-stage>
          <process-record class="mgn-top-70"></process-record>
        </div>
        <div class="bc-item-1">
          <big-camera class="mgn-top-50"></big-camera>
          <soil-moisture class="mgn-top-70"></soil-moisture>
          <insect-survey class="mgn-top-70"></insect-survey>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import amQing from "../assets/img/weather/am-qing.png";
  import amDuoyun from "../assets/img/weather/am-duoyun.png";
  import pmQing from "../assets/img/weather/pm-qing.png";
  import pmDuoyun from "../assets/img/weather/pm-duoyun.png";
  import rain1 from "../assets/img/weather/rain1.png";
  import rain2 from "../assets/img/weather/rain2.png";
  import rain3 from "../assets/img/weather/rain3.png";
  import rain4 from "../assets/img/weather/rain4.png";
  import rain5 from "../assets/img/weather/rain5.png";
  import rain6 from "../assets/img/weather/rain6.png";
  import rain7 from "../assets/img/weather/rain7.png";
  import rain8 from "../assets/img/weather/rain8.png";
  import rain9 from "../assets/img/weather/rain9.png";
  import rain10 from "../assets/img/weather/rain10.png";
  import rain11 from "../assets/img/weather/rain11.png";
  import rain12 from "../assets/img/weather/rain12.png";
  import rain13 from "../assets/img/weather/rain13.png";
  import rain14 from "../assets/img/weather/rain14.png";
  import rain15 from "../assets/img/weather/rain15.png";
  import rain16 from "../assets/img/weather/rain16.png";
  import snow1 from "../assets/img/weather/snow1.png";
  import snow2 from "../assets/img/weather/snow2.png";
  import snow3 from "../assets/img/weather/snow3.png";
  import snow4 from "../assets/img/weather/snow4.png";
  import snow5 from "../assets/img/weather/snow5.png";
  import snow6 from "../assets/img/weather/snow6.png";
  import chen from "../assets/img/weather/chen.png";
  import mai from "../assets/img/weather/mai.png";
  import nodata from "../assets/img/weather/no.png";
  import shachen from "../assets/img/weather/shachen.png";
  import wu from "../assets/img/weather/wu.png";
  import yangsha from "../assets/img/weather/yangsha.png";
  import yin from "../assets/img/weather/yin.png";

  import * as echarts from "echarts";
  import "echarts-amap";

  import leftLine from "@/assets/img/left-line.png";
  import rightLine from "@/assets/img/right-line.png";

  import { getFarmlandList, getFarmlandDetail } from "@/api/index";
  export default {
    data() {
      return {
        weatherIcon: {
          100: amQing,
          101: amDuoyun,
          102: amDuoyun,
          103: amDuoyun,
          104: yin,
          150: pmQing,
          151: pmDuoyun,
          152: pmDuoyun,
          153: pmDuoyun,
          300: rain16,
          301: rain14,
          302: rain12,
          303: rain12,
          304: rain13,
          305: rain2,
          306: rain3,
          307: rain4,
          308: rain5,
          309: rain1,
          310: rain6,
          311: rain6,
          312: rain6,
          313: rain2,
          314: rain2,
          315: rain3,
          316: rain4,
          317: rain5,
          318: rain6,
          350: rain11,
          351: rain11,
          399: rain3,
          400: snow1,
          401: snow2,
          402: snow3,
          403: snow4,
          404: rain3,
          405: rain3,
          406: rain15,
          407: snow2,
          408: snow1,
          409: snow2,
          410: snow3,
          456: snow5,
          457: snow3,
          499: snow2,
          500: wu,
          501: wu,
          502: mai,
          503: yangsha,
          504: chen,
          507: shachen,
          508: shachen,
          509: wu,
          510: wu,
          511: mai,
          512: mai,
          513: mai,
          514: wu,
          515: wu,
          900: amQing,
          901: yin,
          999: nodata
        },
        key: 'ba6db24b4f0b406c939d4963eb7688b5',
        nowWeather: {},
        baseList: [],

        timeStr: '',
        dateStr: '',
        dayStr: '',

        mapObj: null,
        markers: [],
        mapKey: new Date().getTime(),

        farmLandList: [],
        farmLandDetail: {},
        selItem: {},
      }
    },
    components: {
      "land-planting": () => import('./bigcomponents/LandPlanting.vue'),
      "category-proportion": () => import('./bigcomponents/CategoryProportion.vue'),
      "agricultural-materials": () => import("./bigcomponents/AgriculturalMaterials.vue"),
      "box-model": () => import("../components/common/Model.vue"),
      "processing-stage": () => import("./bigcomponents/ProcessingStage.vue"),
      "process-record": () => import("./bigcomponents/ProcessRecord.vue"),
      "big-camera": () => import("./bigcomponents/BigCamera.vue"),
      "soil-moisture": () => import("./bigcomponents/SoilMoisture.vue"),
      "insect-survey": () => import("./bigcomponents/InsectSurvey.vue"),
      "select-box": () => import("../components/common/SelectBox.vue")
    },
    mounted() {
      this.$nextTick(() => {
        this.getDate();
        this.getNowTime();
        this.getFarmlandListEvent();
      });
    },  
    methods: {
      closePage(){
        localStorage.removeItem("st");
        window.close();
      },
      // 获取年月日
      getDate() {
        const date = new Date();
        const y = date.getFullYear(),
          M = date.getMonth() + 1,
          d = date.getDate(),
          day = date.getDay();
        this.dateStr = `${y}/${this.dbNum(M)}/${this.dbNum(d)}`;
        const num = ['日','一','二','三','四','五','六']
        this.dayStr = num[day];
      },
      // 获取当前时间
      getNowTime() {
        this.timer = setInterval(() => {
          const date = new Date();
          const s = date.getSeconds(),
          m = date.getMinutes(),
          h = date.getHours();
          this.timeStr = `${this.dbNum(h)}:${this.dbNum(m)}:${this.dbNum(s)}`;
        }, 1000);
      },
      dbNum(num) {
        return num > 9 ? num : '0'+num;
      },
      // 获取当前城市的经纬度
      getCurCityData(name){
        fetch(`https://geoapi.qweather.com/v2/city/lookup?location=${name}&key=${this.key}`).then((res) => {
          res.json().then((data) => {
            let item = data.location[0];
            this.getCurWeather(`${item.lon},${item.lat}`);
            this.get24HWeather(`${item.lon},${item.lat}`);
          })
        })
      },
      // 获取当前天气
      getCurWeather(location) {
        fetch(`https://devapi.qweather.com/v7/grid-weather/now?location=${location}&key=${this.key}`).then((res) => {
          res.json().then((data) => {
            const result = data.now || {};
            let date = new Date(result.obsTime);
            let y = date.getFullYear(),
              M = this.dbNum(date.getMonth() + 1),
              d = this.dbNum(date.getDay()),
              h = this.dbNum(date.getHours()),
              m = this.dbNum(date.getMinutes()),
              s = this.dbNum(date.getSeconds());
            result['timeStr'] = `${y}-${M}-${d} ${h}:${m}:${s}`;
            this.nowWeather = result;
          })
        })
      },
      // 获取未来24h小时天气
      get24HWeather(location) {
        fetch(`https://devapi.qweather.com/v7/weather/24h?location=${location}&key=${this.key}`).then((res) => {
          res.json().then((data) => {
            const result = data.hourly || [];
            let tempMax = 0, tempMin = 0;
            result.forEach((item) => {
              let date = new Date(item.fxTime);
              item['hourStr'] = date.getHours();
              tempMax = Math.max(tempMax, +item.temp);
              tempMin = Math.min(tempMin, +item.temp);
            });
            tempMax = tempMax + 20;  // 最高温度加6个点
            tempMin = tempMin - 20;  // 最小温度减6个点
            let total = tempMax - tempMin;
            // 高 64
            // 宽 40
            // 坐标点计算
            result.forEach((item) => {
              let step = (+item.temp);
              item['ysn'] = (64/total)*step;
            });
            this.baseList = result;
            this.drawLineEvent(result);
          })
        })
      },
      // 画线
      drawLineEvent(arr){
        let c = document.getElementById('ctxs');
        let ctx = c.getContext("2d");
        let xStart = 18;
        let step = 60;
        ctx.beginPath();
        ctx.moveTo(xStart, arr[0].ysn);
        ctx.lineTo(xStart + 1*step, arr[1].ysn);
        ctx.lineTo(xStart + 2*step, arr[2].ysn);
        ctx.lineTo(xStart + 3*step, arr[3].ysn);
        ctx.lineTo(xStart + 4*step, arr[4].ysn);
        ctx.lineTo(xStart + 5*step, arr[5].ysn);
        ctx.lineTo(xStart + 6*step, arr[6].ysn);
        ctx.lineTo(xStart + 7*step, arr[7].ysn);
        ctx.lineTo(xStart + 8*step, arr[8].ysn);
        ctx.lineTo(xStart + 9*step, arr[9].ysn);
        ctx.lineTo(xStart + 10*step, arr[10].ysn);
        ctx.lineTo(xStart + 11*step, arr[11].ysn);
        ctx.lineTo(xStart + 12*step, arr[12].ysn);
        ctx.lineTo(xStart + 13*step, arr[13].ysn);
        ctx.lineTo(xStart + 14*step, arr[14].ysn);
        ctx.lineTo(xStart + 15*step, arr[15].ysn);
        ctx.lineTo(xStart + 16*step, arr[16].ysn);
        ctx.lineTo(xStart + 17*step, arr[17].ysn);
        ctx.lineTo(xStart + 18*step, arr[18].ysn);
        ctx.lineTo(xStart + 19*step, arr[19].ysn);
        ctx.lineTo(xStart + 20*step, arr[20].ysn);
        ctx.lineTo(xStart + 21*step, arr[21].ysn);
        ctx.lineTo(xStart + 22*step, arr[22].ysn);
        ctx.lineTo(xStart + 23*step, arr[23].ysn);
        ctx.lineWidth = 1;
        ctx.strokeStyle = "#ffffff";
        ctx.stroke();
        this.dreawPoint(ctx, xStart, arr[0].ysn);
        this.dreawPoint(ctx, xStart + 1*step, arr[1].ysn);
        this.dreawPoint(ctx, xStart + 2*step, arr[2].ysn);
        this.dreawPoint(ctx, xStart + 3*step, arr[3].ysn);
        this.dreawPoint(ctx, xStart + 4*step, arr[4].ysn);
        this.dreawPoint(ctx, xStart + 5*step, arr[5].ysn);
        this.dreawPoint(ctx, xStart + 6*step, arr[6].ysn);
        this.dreawPoint(ctx, xStart + 7*step, arr[7].ysn);
        this.dreawPoint(ctx, xStart + 8*step, arr[8].ysn);
        this.dreawPoint(ctx, xStart + 9*step, arr[9].ysn);
        this.dreawPoint(ctx, xStart + 10*step, arr[10].ysn);
        this.dreawPoint(ctx, xStart + 11*step, arr[11].ysn);
        this.dreawPoint(ctx, xStart + 12*step, arr[12].ysn);
        this.dreawPoint(ctx, xStart + 13*step, arr[13].ysn);
        this.dreawPoint(ctx, xStart + 14*step, arr[14].ysn);
        this.dreawPoint(ctx, xStart + 15*step, arr[15].ysn);
        this.dreawPoint(ctx, xStart + 16*step, arr[16].ysn);
        this.dreawPoint(ctx, xStart + 17*step, arr[17].ysn);
        this.dreawPoint(ctx, xStart + 18*step, arr[18].ysn);
        this.dreawPoint(ctx, xStart + 19*step, arr[19].ysn);
        this.dreawPoint(ctx, xStart + 20*step, arr[20].ysn);
        this.dreawPoint(ctx, xStart + 21*step, arr[21].ysn);
        this.dreawPoint(ctx, xStart + 22*step, arr[22].ysn);
        this.dreawPoint(ctx, xStart + 23*step, arr[23].ysn);
      },
      dreawPoint(ctx, cx, cy){
        ctx.save();
        ctx.lineWidth = 1
        ctx.beginPath()
        ctx.arc(cx, cy, 2, 0, Math.PI * 2)
        ctx.fillStyle = "#ffffff"
        ctx.fill()
        ctx.strokeStyle = "#ffffff"
        ctx.stroke()
        ctx.closePath()
        ctx.restore()
      },

      // 获取地块下拉列表
      getFarmlandListEvent(){
        getFarmlandList().then((res) => {
          const result = res.data || [];
          result.forEach((item) => {
            item['name'] = item.desc
          });
          this.farmLandList = result;
          // 广东 茂名市 茂南区
          let findItem = result.find((item) => {
            return item.name.indexOf("茂名市") > -1 || item.name.indexOf("茂南区") > -1;
          });
          if(findItem){
            this.getFarmlandDetailEvent(findItem);
          } else {
            this.getFarmlandDetailEvent(result[0]);
          };
        })
      },
      getFarmlandDetailEvent(item){
        if(!item || !item?.type){
          return;
        }
        this.selItem = item;
        getFarmlandDetail(item.type).then((res) => {
          const result = res.data || {};
          result["name"] = result.cityText;
          let pArr = result.pointArr ? JSON.parse(result.pointArr) : "";
          if(pArr && pArr?.length){
            result['pointArray'] = pArr;
            result["center"] = pArr[0];
          };
          this.farmLandDetail = result;
          this.mapKey = new Date().getTime();
          this.initMap();
        });
      },
      selEvent(item){
        this.selItem = item;
        this.getFarmlandDetailEvent(item);
      },
      initMap(callback){
        let that = this;
        let getItem = this.farmLandDetail;
        this.getCurCityData(getItem.cityText);
        AMap.plugin(
          ["AMap.DistrictSearch", "AMap.MapType", "AMap.CustomLayer"],
          function() {
            let district = new AMap.DistrictSearch({
              extensions: "all",
              level: "city",
            });
            district.search(getItem.name, function (status, result) {
              let bounds = result.districtList[0]?.boundaries;
              let districts = result.districtList[0]?.districtList;
              let cc = getItem.center;
              if(districts?.length){
                let findItem = districts.find((item) => item.name === getItem.countyText);
                if(findItem && findItem?.center?.lng && findItem?.center?.lat){
                  cc = [findItem?.center?.lng, findItem?.center?.lat];
                };
              };
              let mask = [];
              if(bounds?.length){
                for (let i = 0; i < bounds.length; i++) {
                  mask.push([bounds[i]]);
                };
              };
              let myChart = echarts.init(document.getElementById("mapData"));
              let option = {
                animation: false,
                amap: {
                  mask: mask,
                  center: cc,
                  viewMode: "3D",
                  zoom: 13,
                  defaultCursor: "auto",
                },
                series: [],
              };
              myChart.setOption(option);
              let map = myChart.getModel().getComponent("amap").getAMap();
              let mapType = new AMap.MapType({
                defaultType: 1,
                showTraffic: true,
                showRoad: true
              });
              map.addControl(mapType);
              mapType.hide();
              // 名字
              let LabelsData = [];
              if(districts?.length){
                for (let i = 0; i < districts.length; i++) {
                  let config = {
                    name: "",
                    zooms: [4, 13],
                    zIndex: 1,
                    opacity: 1,
                    text: {
                      content: "",
                      direction: "center",
                      offset: [0, 0],
                      zooms: [3, 20],
                      style: {
                        fontSize: 12,
                        fontWeight: "normal",
                        fillColor: "#fff",
                        strokeColor: "rgba(0,0,0,1)",
                        strokeWidth: 1,
                      },
                    },
                  };
                  let district = districts[i];
                  let name = district.name;
                  config.text.content = name;
                  config.position = [district.center.lng, district.center.lat];
                  LabelsData.push(config);
                  let district2 = new AMap.DistrictSearch({
                    extensions: "all",
                    level: "district",
                  });
                  if(bounds?.length){
                    district2.search(name, function (status, result) {
                      for (let ii = 0; ii < bounds.length; ii++) {
                        new AMap.Polyline({
                          map: map,
                          path: bounds[ii],
                          strokeColor: "#2687D0",
                          strokeWeight: 2,
                        });
                      }
                    });
                  }
                };
              };
              // 边界
              if(bounds?.length){
                for (let i = 0; i < bounds.length; i++) {
                  new AMap.Polyline({
                    map: map,
                    path: bounds[i],
                    strokeColor: "#2687D0",
                    strokeWeight: 6,
                  });
                };
              };
              map.on("complete", function () {
                that.setMapBg();
                that.mapObj = map;
                if(typeof callback === 'function'){
                  callback();
                };
                let layer = new AMap.LabelsLayer({
                  collision: false,
                  animation: false,
                });
                // 名称绘制
                for (let i = 0; i < LabelsData.length; i++) {
                  let labelsMarker = new AMap.LabelMarker(LabelsData[i]);
                  layer.add(labelsMarker);
                };
                map.add(layer);
                // 绘制自定义区域
                const polygon = new AMap.Polygon({
                  path: getItem.pointArray,
                  strokeColor: '#18FEFE',
                  strokeWeight: 2,
                  strokeOpacity: 0.5,
                  fillOpacity: 0.1,
                  fillColor: '#38EAFF',
                  zIndex: 50
                });
                map.add(polygon);
              });
            })
          }
        );
      },
      // 地图背景透明设置
      setMapBg() {
        let timer = null;
        let ele = document.getElementsByClassName("amap-container");
        if(ele?.length){
          timer && clearInterval(timer);
          ele[0].style.background = "none";
          timer = null;
        } else {
          timer = setInterval(() => {
            this.setMapBg();
          }, 1000);
        }
      },
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
  }
</script>
<style scoped lang="less">
  .mgn-top-70 {
    margin-top: 60px;
  }
  .mgn-top-50 {
    margin-top: 40px;
  }
  .flex-wrap {
    display: flex;
    flex-wrap: wrap;
  }
  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .flex-y-center {
    display: flex;
    align-items: center;
  }
  .flex-x-center {
    display: flex;
    justify-content: center;
  }
  .flex-x-between {
    display: flex;
    justify-content: space-between;
  }
  .big-con {
    position: relative;
    width: 100%;
    height: 100%;
    .b-header {
      position: relative;
      width: 100%;
      height: 100px;
      padding: 36px 110px 0 100px;
      .bh-img {
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      .bh-content {
        position: relative;
        z-index: 3;
        position: relative;
        width: 100%;
        height: 100%;
        .weather {
          height: 100%;
          .w-icon {
            width: 48px;
            height: 48px;
          }
          .w-txt {
          position: relative;
          font-size: 34px;
          font-weight: 700;
          color: #FFFFFF;
          line-height: 34px;
          margin-left: 8px;
          .s {
            position: absolute;
            top: 0;
            right: -15px;
            font-size: 18px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 18px;
          }
          .info {
            position: absolute;
            bottom: 0;
            width: 300px;
            right: -325px;
            font-size: 18px;
            font-weight: 400;
            color: rgba(255,255,255,0.702);
            line-height: 18px;
          }
        }
        }
        .time {
          margin-left: auto;
          height: 100%;
          .date {
            flex-direction: column;
            height: 100%;
            text-align: right;
            .t {
              font-size: 18px;
              font-weight: 400;
              color: rgba(255,255,255,0.702);
              line-height: 18px;
            }
            .d {
              font-size: 18px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 18px;
              margin-top: 5px;
            }
          }
          .time-info {
            height: 100%;
            font-size: 34px;
            font-weight: 700;
            color: #FFFFFF;
            margin: 0 40px 0 24px;
          }
          .login-state {
            width: 48px;
            height: 48px;
            cursor: pointer;
            .l-img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .b-container {
      position: relative;
      width: 100%;
      height: calc(100% - 100px);
      padding: 10px 80px;
      overflow: auto;
      .left-icon {
        position: fixed;
        z-index: 3;
        left: 30px;
        top: 122px;
        width: 23px;
        height: calc(100% - 122px);
      }
      .right-icon {
        position: fixed;
        z-index: 3;
        right: 30px;
        top: 122px;
        width: 23px;
        height: calc(100% - 122px);
      }
      .bc-main {
        width: 100%;
        .bc-item-1 {
          width: 600px;
          .w-content {
            width: 100%;
            height: 338px;
            .wc-info {
              width: 100%;
              height: 100px;
              .wc-img {
                width: 100px;
                height: 100px;
                margin-right: 20px;
              }
              .wc-num {
                height: 100%;
                .num1 {
                  font-size: 38px;
                  font-weight: 700;
                  color: #4ADDFF;
                  line-height: 38px;
                }
                .num2 {
                  font-size: 16px;
                  font-weight: 400;
                  color: #4ADDFF;
                  line-height: 16px;
                  margin: 16px 0 12px 0;
                }
                .num3 {
                  font-size: 18px;
                  font-weight: 400;
                  color: #4ADDFF;
                  line-height: 18px;
                }
              }
              .wc-line {
                width: 1px;
                height: 100%;
                background: #243256;
                margin: 0 20px;
              }
              .wc-detail{
                width: 328px;
                height: 100%;
                .wc-d-list {
                  width: 100%;
                  padding-top: 8px;
                  .wc-d-item {
                    width: 50%;
                    height: 18px;
                    padding: 0 20px 0 20px;
                    font-size: 18px;
                    font-weight: 400;
                    color: rgba(255,255,255,0.702);
                    margin-bottom: 10px;
                    line-height: 18px;
                    .num {
                      font-size: 18px;
                      font-weight: 400;
                      color: #FFFFFF;
                      margin-left: auto;
                    }
                  }
                }
                .wc-d-notice {
                  position: relative;
                  width: 100%;
                  height: 40px;
                  background: rgb(9,32,61);
                  font-size: 18px;
                  font-weight: 400;
                  color: #4ADDFF;
                  padding-left: 44px;
                  .n-icon {
                    position: absolute;
                    left: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 21px;
                    height: 23px;
                  }
                }
              }
            }
            .wc-list-content {
              width: 100%;
              height: 200px;
              margin-top: 30px;
              .wc-r-list {
                position: relative;
                width: 100%;
                height: 200px;
                overflow-x: scroll;
                overflow-y: hidden;
                white-space: nowrap;
                .num-part {
                  position: absolute;
                  z-index: 3;
                  left: 0;
                  top: 20px;
                  width: 1420px;
                  height: 40px;
                }
                .r-item {
                  display: inline-block;
                  width: 40px;
                  height: 100%;
                  margin-right: 20px;
                  overflow: hidden;
                  cursor: pointer;
                  .r-time {
                    font-size: 18px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 18px;
                    text-align: center;
                  }
                  .r-tag {
                    width: 100%;
                    height: 40px;
                    margin-top: 10px;
                  }
                  .r-img {
                    display: block;
                    width: 32px;
                    height: 32px;
                    margin: 0 auto;
                  }
                  .r-num {
                    font-size: 18px;
                    font-weight: 700;
                    color: #FFFFFF;
                    line-height: 18px;
                    text-align: center;
                    margin-top: 10px;
                  }
                  .r-wind {
                    font-size: 18px;
                    font-weight: 400;
                    color: rgba(255,255,255,0.702);
                    line-height: 18px;
                    text-align: center;
                    margin-top: 10px;
                  }
                }
                .r-item:last-child {
                  margin-right: 0;
                }
              }
            }
          }
        }
        .bc-item-2 {
          position: relative;
          width: 1860px;
          padding: 0 20px;
          .title-part {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 9;
            width: 100%;
            height: 32px;
            .t-select1 {
              position: absolute;
              right: 0;
              top: 0;
              width: 200px;
            }
          }
          .map {
            position: relative;
            z-index: 0;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
</style>